import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux';
import { SidebarDistributionLineAreaMasterPostDataAPI } from '../../../../../../Redux/SidebarMasterSlice/WaterSupplySidebarSlice/WaterSupplyDistributionLineAreaMasterSlice';
import { useAuthState } from '../../../../../../Helper/Context';
import { JunctionNameDataDDL } from '../../../../../../Components/CommonDDL/JunctionNameDataDDL';
import { DistributionLineLocationDataDDL } from '../../../../../../Components/CommonDDL/DistributionLineLocationDataDDL';


export default function WaterSupplySidebarMasterLocationWiseAreaMasterPopup(props) {
    const { handleOnCloseClick, open, Flag, apiFlag, rowData, handleIsPost, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch();

    const [JunctionNameDDL, setJunctionNameDDL] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_Distri_WS_LocationID : 0,
        Label: Flag === 'Update' ? rowData.locationDetails : "Select...",
    })
    // console.log(rowData.locationDetails)
    const [AreaName, setAreaName] = useState(Flag === 'Update' ? rowData.areaDetails : '')
    const [IsClear, setIsClear] = useState(false)

    const [IsOpen, setIsOpen] = useState(false)


    const handleClear = () => {
        setIsClear(!IsClear)
        setAreaName('')
        setJunctionNameDDL({
            ...JunctionNameDDL,
            ID: 0,
            Label: 'Select...',
        })
    }

    const handlePost = () => {
        const data = {
            M_TTP_AreaDetailsID: Flag === 'Update' ? rowData.m_ttP_AreaDetailsID : '0',
            M_TTP_LocationID: JunctionNameDDL.ID,
            M_Distri_WS_AreaDetailsID: Flag === 'Update' ? rowData.m_Distri_WS_AreaDetailsID : '0',
            M_Distri_WS_LocationID: JunctionNameDDL.ID,
            AreaDetails: AreaName,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
            DashProjectTypeId: DashProjectTypeId
        }
        dispatch(SidebarDistributionLineAreaMasterPostDataAPI({ data }))
    }
    const { isPostLoading } = useSelector(state => state.SidebarDistributionLineAreaMasterPostData)


    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="modal-dialog water_pop modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Location Wise Area Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">
                                {
                                    (DashProjectTypeId == '6' || DashProjectTypeId == '9') ?
                                        <>
                                            <div className="col-12 col-md-6 col-lg-6">
                                                <DistributionLineLocationDataDDL
                                                    DistributionLineLocationDDL={JunctionNameDDL}
                                                    setDistributionLineLocationDDL={setJunctionNameDDL}
                                                    WardName=''
                                                    Flag={Flag}
                                                    rowData={rowData}
                                                    DashProjectTypeId={DashProjectTypeId}
                                                />
                                            </div>
                                        </>
                                        :
                                        <div className="col-12 col-md-6 col-lg-6">
                                            <JunctionNameDataDDL
                                                JunctionNameDDL={JunctionNameDDL}
                                                setJunctionNameDDL={setJunctionNameDDL}
                                                WardName=''
                                            />
                                        </div>
                                }

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Area Name </b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="AreaName"
                                            value={AreaName}
                                            onChange={(e) => setAreaName(e.target.value)}

                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-lg-12 pt-lg-5 pt-md-4">
                                <div className="btn-action d-flex justify-content-end">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => (handlePost(), handleClear())}
                                        disabled={
                                            JunctionNameDDL.ID == 0 || AreaName == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}